'use strict';

var _objectWithoutProperties = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _excluded = ["config", "items", "leave", "position", "remove", "showIndicator", "top", "shift"],
    _excluded2 = ["life"];

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('./extends-214be52a.js');

var defineProperty = require('./defineProperty-754b29ce.js');

var _styled = require('styled-components');

var React = require('react');

var index = require('./index-6b8189f0.js');

var reactSpringWeb_esm = require('./react-spring-web.esm-b5843e07.js');

var RootPortal = require('./RootPortal.js');

var Viewport = require('./Viewport-0c0a0c23.js');

var components = require('./components.js');

var Theme = require('./Theme.js');

var constants = require('./constants.js');

var textStyles = require('./text-styles.js');

var springs = require('./springs.js');

require('./_commonjsHelpers-b3309d7b.js');

require('react-dom');

require('./Root-e3b39caa.js');

require('./breakpoints.js');

require('./theme-dark.js');

require('./theme-light.js');

require('./environment.js');

require('./miscellaneous.js');

require('./color.js');

require('./font.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _styled__default = /*#__PURE__*/_interopDefaultLegacy(_styled);

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var id = 0;

var move = function move(pixel) {
  return "translate3d(0,".concat(pixel, "px,0)");
};

var ToastContext = /*#__PURE__*/React__default["default"].createContext(function () {
  throw new Error("For Toast to work it needs to be part of a ToastHub's tree, which has to be declared at an upper level!");
});

var ToastHubProvider = /*#__PURE__*/function (_React__default$defau) {
  _inherits(ToastHubProvider, _React__default$defau);

  var _super = _createSuper(ToastHubProvider);

  function ToastHubProvider() {
    var _this2;

    _classCallCheck(this, ToastHubProvider);

    var _this;

    _this2 = _super.apply(this, arguments);
    _this = _assertThisInitialized(_this2);

    defineProperty._defineProperty(_assertThisInitialized(_this2), "state", {
      items: [],
      leaving: [],
      preLeaving: []
    });

    defineProperty._defineProperty(_assertThisInitialized(_this2), "cancelMap", new WeakMap());

    defineProperty._defineProperty(_assertThisInitialized(_this2), "add", function (msg) {
      var threshold = _this2.props.threshold;

      _this2.setState(function (state) {
        // This calls cancel on all leaving animations that stack up too much
        if (threshold !== Infinity) {
          state.leaving.slice(threshold - 1).forEach(function (item) {
            return _this2.cancel(item, true);
          });
        }

        return {
          items: [].concat(_toConsumableArray(state.items), [{
            key: id++,
            msg: msg
          }]),
          preLeaving: []
        };
      });
    });

    defineProperty._defineProperty(_assertThisInitialized(_this2), "remove", function (item) {
      _this2.setState(function (state) {
        return {
          items: state.items.filter(function (i) {
            return i.key !== item.key;
          }),
          leaving: state.leaving.includes(item) ? state.leaving : [item].concat(_toConsumableArray(state.leaving))
        };
      });
    });

    defineProperty._defineProperty(_assertThisInitialized(_this2), "config", function (item, state) {
      var config = springs.springs.lazy; // Return custom configs on leave (includes the life-line duration)

      return state === 'leave' ? [{
        duration: _this2.props.timeout
      }, config, config] : config;
    });

    defineProperty._defineProperty(_assertThisInitialized(_this2), "cancel", function (item) {
      var secondPass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (_this.cancelMap.has(item)) {
        var fn = _this.cancelMap.get(item);

        fn(); // There are 3 passes: lifeline, opacity->0, height->0

        if (secondPass) fn();
      }
    });

    defineProperty._defineProperty(_assertThisInitialized(_this2), "leave", function (item) {
      return /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(next, cancel) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Save cancel so that it can be used interactively
                  _this2.cancelMap.set(item, cancel); // Lifeline first


                  _context.next = 3;
                  return next({
                    to: {
                      life: '0%'
                    }
                  });

                case 3:
                  // Add to the pre-leaving list, to know when there are no more toasts
                  // displayed even though they are still finishing their leaving transition.
                  _this2.setState(function (state) {
                    return {
                      preLeaving: [].concat(_toConsumableArray(state.preLeaving), [item])
                    };
                  }); // Then fade out


                  _context.next = 6;
                  return next({
                    to: {
                      opacity: 0
                    }
                  });

                case 6:
                  _context.next = 8;
                  return next({
                    to: {
                      height: 0
                    }
                  }, true);

                case 8:
                  _this2.setState(function (state) {
                    return {
                      leaving: state.leaving.filter(function (i) {
                        return i.key !== item.key;
                      }),
                      preLeaving: state.preLeaving.filter(function (i) {
                        return i.key !== item.key;
                      })
                    };
                  });

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }();
    });

    return _this2;
  }

  _createClass(ToastHubProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          showIndicator = _this$props.showIndicator,
          position = _this$props.position,
          top = _this$props.top,
          shift = _this$props.shift;
      var _this$state = this.state,
          items = _this$state.items,
          leaving = _this$state.leaving,
          preLeaving = _this$state.preLeaving;
      var renderList = items.length > 0 || leaving.length > 0;
      var itemsVisible = leaving.length === preLeaving.length && leaving.length > 0 ? false : renderList;
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(ToastContext.Provider, {
        value: {
          itemsVisible: itemsVisible,
          add: this.add
        }
      }, children), renderList && /*#__PURE__*/React__default["default"].createElement(RootPortal["default"], null, /*#__PURE__*/React__default["default"].createElement(ToastList, _extends._extends({
        config: this.config,
        items: items,
        leave: this.leave,
        position: position,
        remove: this.remove,
        showIndicator: showIndicator,
        top: top
      }, components.stylingProps(this), {
        shift: shift
      }))));
    }
  }]);

  return ToastHubProvider;
}(React__default["default"].PureComponent); // ToastList is separated from ToastHubProvider so we can skip its rendering


defineProperty._defineProperty(ToastHubProvider, "propTypes", {
  children: index.PropTypes.node,
  position: index.PropTypes.PropTypes.oneOf(['left', 'center', 'right']),
  shift: index.PropTypes.number,
  showIndicator: index.PropTypes.bool,
  threshold: index.PropTypes.number,
  timeout: index.PropTypes.number,
  top: index.PropTypes.bool
});

defineProperty._defineProperty(ToastHubProvider, "defaultProps", {
  position: 'right',
  showIndicator: false,
  threshold: Infinity,
  timeout: 4000,
  top: false
});

var ToastList = /*#__PURE__*/React__default["default"].memo(function ToastList(_ref) {
  var config = _ref.config,
      items = _ref.items,
      leave = _ref.leave,
      position = _ref.position,
      remove = _ref.remove,
      showIndicator = _ref.showIndicator,
      top = _ref.top,
      shift = _ref.shift,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = Theme.useTheme();

  var _Viewport$useViewport = Viewport.useViewport(),
      below = _Viewport$useViewport.below;

  var spacing = below('medium') ? 2 * constants.GU : 3 * constants.GU;
  return /*#__PURE__*/React__default["default"].createElement(_StyledDiv, _extends._extends({}, props, {
    $_css: top ? "".concat(spacing, "px") : 'unset',
    $_css2: top ? 'unset' : "".concat(spacing, "px"),
    $_css3: spacing + (shift || 0),
    $_css4: spacing + (shift || 0),
    $_css5: top ? 'column-reverse' : 'column',
    $_css6: function () {
      if (below('medium')) return 'center';
      if (position === 'left') return 'flex-start';
      if (position === 'right') return 'flex-end';
      return 'center';
    }()
  }), /*#__PURE__*/React__default["default"].createElement(reactSpringWeb_esm.Transition, {
    native: true,
    items: items,
    keys: function keys(item) {
      return item.key;
    },
    from: {
      opacity: 0,
      height: 0,
      life: '100%',
      transform: move(30)
    },
    enter: {
      opacity: 1,
      height: 'auto',
      transform: move(0)
    },
    leave: leave,
    onRest: remove,
    config: config
  }, function (_ref2, item) {
    var life = _ref2.life,
        props = _objectWithoutProperties(_ref2, _excluded2);

    return item && /*#__PURE__*/React__default["default"].createElement(_StyledAnimatedDiv, {
      style: props,
      $_css7: below('medium') ? '100%' : '42ch'
    }, /*#__PURE__*/React__default["default"].createElement(_StyledDiv2, {
      $_css8: 6 * constants.GU,
      $_css9: top ? '0' : "".concat(1.25 * constants.GU, "px"),
      $_css10: top ? "".concat(1.25 * constants.GU, "px") : '0',
      $_css11: 2.5 * constants.GU,
      $_css12: textStyles.textStyle('body3'),
      $_css13: theme.floatingContent,
      $_css14: theme.floating.alpha(0.95)
    }, showIndicator && /*#__PURE__*/React__default["default"].createElement(_StyledAnimatedDiv2, {
      style: {
        right: life
      },
      $_css15: top ? "".concat(1.25 * constants.GU, "px") : '0'
    }), /*#__PURE__*/React__default["default"].createElement("p", null, item.msg)));
  }));
});
ToastList.propTypes = {
  config: index.PropTypes.func,
  items: index.PropTypes.array,
  leave: index.PropTypes.func,
  position: index.PropTypes.PropTypes.oneOf(['left', 'center', 'right']),
  remove: index.PropTypes.func,
  shift: index.PropTypes.number,
  showIndicator: index.PropTypes.bool,
  top: index.PropTypes.bool
};

var useToast = function useToast() {
  return React.useContext(ToastContext).add;
};

var Toast = function Toast(props) {
  return props.children(useToast());
};

var _StyledDiv = _styled__default["default"]("div").withConfig({
  displayName: "ToastHub___StyledDiv",
  componentId: "sc-1cfhkh0-0"
})(["position:fixed;z-index:1000;top:", ";bottom:", ";left:", "px;right:", "px;display:flex;margin:0 auto;flex-direction:", ";pointer-events:none;align-items:", ";"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
}, function (p) {
  return p.$_css5;
}, function (p) {
  return p.$_css6;
});

var _StyledAnimatedDiv = _styled__default["default"](reactSpringWeb_esm.animated.div).withConfig({
  displayName: "ToastHub___StyledAnimatedDiv",
  componentId: "sc-1cfhkh0-1"
})(["box-sizing:border-box;position:relative;width:", ";"], function (p) {
  return p.$_css7;
});

var _StyledDiv2 = _styled__default["default"]("div").withConfig({
  displayName: "ToastHub___StyledDiv2",
  componentId: "sc-1cfhkh0-2"
})(["display:flex;align-items:center;overflow:hidden;height:", "px;margin-top:", ";margin-bottom:", ";padding:0 ", "px;", ";color:", ";background:", ";border-radius:", "px;"], function (p) {
  return p.$_css8;
}, function (p) {
  return p.$_css9;
}, function (p) {
  return p.$_css10;
}, function (p) {
  return p.$_css11;
}, function (p) {
  return p.$_css12;
}, function (p) {
  return p.$_css13;
}, function (p) {
  return p.$_css14;
}, constants.MEDIUM_RADIUS);

var _StyledAnimatedDiv2 = _styled__default["default"](reactSpringWeb_esm.animated.div).withConfig({
  displayName: "ToastHub___StyledAnimatedDiv2",
  componentId: "sc-1cfhkh0-3"
})(["position:absolute;bottom:", ";left:0;width:auto;height:5px;background-image:linear-gradient( 130deg,#00b4e6,#00f0e0 );"], function (p) {
  return p.$_css15;
});

exports.Toast = Toast;
exports.ToastContext = ToastContext;
exports["default"] = ToastHubProvider;
exports.useToast = useToast;